import React, { useCallback, useMemo, useState } from 'react';
import { Description, SubTitle, DivRelative, Link } from '../../components/layouts';
import Sequence from '../../components/sequence';
import { getSeqFrames, getTrack, pureTrans } from '../../helpers';
import Visibility from '../../components/Visibility';
import './style.scss';
import { SeqencePlaceholder } from '../../components/sequence/Placeholder';
import { AppContext } from '../../Context';

const track = getTrack({ block: 21 });

const FRAME_LENGTH = 55;

export function Charge({ mobile = false }) {
  const [frozen, freeze] = useState(true);
  const [framesLoaded, setFramesLoaded] = React.useState(false);
  const [progress, setProgress] = useState(0);
  const { index, a1, a2, a3, a4 } = useMemo(() => {
    return {
      index: pureTrans(progress, [0, 0.75], [0, FRAME_LENGTH - 1], 0),
      a1: pureTrans(progress, [0, 0.75], [1, 1], 3),
      a2: pureTrans(progress, [0, 0.75], [0, 0], 3),
      a3: pureTrans(progress, [0, 0.75], [1, 1], 3),
      a4: pureTrans(progress, [0, 0.75], [0, 0], 3)
    };
  }, [progress]);

  const handleUpdate = useCallback(
    (e, { calculations }) => {
      const { percentagePassed, pixelsPassed, height, offScreen } = calculations;
      freeze(offScreen || pixelsPassed <= -1000 || pixelsPassed >= height + 1000);
      setProgress(percentagePassed);
    },
    [setProgress, freeze]
  );

  const { webpSupport, webpDetectionFinished } = React.useContext(AppContext);

  const frames = useMemo(() => {
    return getSeqFrames({
      prefix: 'charge',
      mobile,
      webpSupport: false,
      len: FRAME_LENGTH
    });
  }, [webpSupport, mobile]);

  const onFramesLoaded = useCallback(() => {
    setFramesLoaded(true);
  }, [setFramesLoaded]);

  const seqReady = !frozen && webpDetectionFinished;
  return (
    <Visibility fireOnMount offset={[-1000, 1000]} onUpdate={handleUpdate} className="page-section section-26 inverted" data-track={track}>
      <div className="sticky-content">
        <DivRelative>
          <div className="section-content left">
            <div style={{ opacity: a1, transform: `translateY(${a2}%) translateZ(0)` }}>
              <SubTitle>一不留神，就充满了</SubTitle>
              <Description>
                让你的手机快速回血，畅快生活享不停。
                <Link bordered={false} href="https://shop.vivo.com.cn/product/10006160" text="购买我的X60 Pro" position={21} />
              </Description>
            </div>
          </div>
          <div className="section-background" data-visible={framesLoaded}>
            <div className="sequence-wrapper" style={{ transform: `scale(${a3}) translateZ(0)` }}>
              <Sequence current={index} frames={frames} onload={onFramesLoaded} active={seqReady} />
              {!mobile && <div className="dark-mask" style={{ backgroundColor: `rgba(0,0,0,${a4})` }} />}
              <SeqencePlaceholder src={frames[frames.length - 1]} visible={!seqReady || !framesLoaded} />
            </div>
          </div>
        </DivRelative>
      </div>
    </Visibility>
  );
}
